import opencc from './opencc'
import { isMagicbuyProject } from '@g/utils/projectUtils'

function getAppOptionApiPath (project) {
  if (isMagicbuyProject(project)) {
    return '/option/v1frontend/option/app-mg'
  }
  return '/option/v1frontend/option/app'
}

const state = {
  optionApp: {
    fe_line_link: {},
  },
  optionCoApp: {},
}

const getters = {
}

const mutations = {
  setOptionApp (state, data) {
    state.optionApp = data
  },
  setOptionCoApp (state, data) {
    state.optionCoApp = data
  },
}

const actions = {
  app ({ commit, rootState }, params) {
    return rootState.axios.post(getAppOptionApiPath(rootState.project), params).then(res => {
      commit('setOptionApp', {
        ...res.data.model,
        fe_line_link: JSON.parse(res.data.model.fe_line_link || '{}'),
      })
      return res
    })
  },
  viewByGroupkey ({ state, commit, rootState }, params) {
    // groupKey:'xxx'
    return rootState.axios.get('/option/v1frontend/option/view-by-groupkey', { params })
  },
  // appco ({ state, commit, rootState }, params) {
  //   return rootState.axios.post('/option/v1consolidator/option/app', {
  //     group: 'appco'
  //   }).then(res => {
  //     commit('setOptionCoApp', res.data.model)
  //     return res
  //   })
  // },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    opencc
  }
}
